import { WarningIcon } from '@phosphor-icons/react'
import * as Dialog from '@radix-ui/react-dialog'
import { DefaultButton } from '../../components/buttons/default-button.tsx'
import { GhostButton } from '../../components/buttons/ghost-button.tsx'
import * as styles from './abandon-changes-dialog.css.ts'

type AbandonChangesDialogProps = {
  open: boolean
  onCancel: () => unknown
  onAbandon: () => unknown
}

export const AbandonChangesDialog: React.FC<AbandonChangesDialogProps> = ({ open, onCancel, onAbandon }) => {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onCancel()
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content} aria-describedby={undefined}>
          <Dialog.Title className={styles.title}>
            <WarningIcon className={styles.icon} size={32} weight="fill" aria-hidden={true} />
            Abandon changes?
          </Dialog.Title>

          <Dialog.Description className={styles.description}>
            You have unsaved changes to your Organization preferences. How would you like to proceed?
          </Dialog.Description>

          <div className={styles.buttons}>
            <GhostButton type="secondary" onClick={onCancel}>
              Cancel
            </GhostButton>
            <DefaultButton buttonType="secondary" onClick={onAbandon}>
              Abandon
            </DefaultButton>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
